/** Calls this portal's JSON API, throwing the server's `{ error }` message on failure. */
export async function api<T>(path: string, init?: RequestInit): Promise<T> {
	const response = await fetch(path, { ...init, credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } })
	if (!response.ok) {
		const body = (await response.json().catch(() => null)) as { error?: string } | null
		throw new Error(body?.error ?? `Request failed (${response.status}).`)
	}
	return (response.status === 204 ? undefined : await response.json()) as T
}
